<div class="balance-chart-point"
    [style.backgroundColor]="color"
></div>
